import Blocks from '@/components/Blocks';
import Container from '@/components/Container';
import Layout from '@/components/Layout';
import queryPrivacyPolicy from '@/lib/wp/privacy-policy/queryPrivacyPolicy';
import getPostTypeStaticProps from '@/functions/wp/posts/getPostTypeStaticProps';
import getPostTypeStaticPaths from '@/functions/wp/posts/getPostTypeStaticPaths';
import { useQuery } from '@apollo/client';
import styles from './PrivacyPolicy.module.scss';

const postType = 'page'

export default function PrivacyPolicy({post}){
  const { loading, error, data } = useQuery(queryPrivacyPolicy, {variables: {title: "Privacy Policy"}})

  const blocks = data?.pages?.edges[0]?.node?.blocksJSON;

  if (loading) {
    return <div>Loading Privacy Policy Page...</div>;
  }
 
  return (
    <Layout seo={{ ...post?.seo }}>
      <div className={styles.privacyContainer}>
        <Container>
          <div className={styles.textLeft}>
            <Blocks blocks={JSON.parse(blocks)} />
          </div>
        </Container>
      </div>
    </Layout>
  );
};

/**
 * Get post static paths.
 *
 * @return {object} Array of paths and fallbacks
 */
 export async function getStaticPaths() {
  return getPostTypeStaticPaths(postType);
}

/**
 * Get post static props
 *
 * @param  {object} context             context for current post
 * @param  {object} context.params      route parameters for current post
 * @param           context.preview
 * @param           context.previewData
 * @param           context.preview
 * @param           context.previewData
 * @return {object}                     post props
 */
export async function getStaticProps({ params, preview, previewData }) {
  return getPostTypeStaticProps({ slug: 'privacy-policy' }, postType, preview, previewData);
}
